import { api } from './_httpClient'

const list = async () => api.get('/banner/list')

const createUpdate = async payload => api.post('/banner', payload)

const deleteB = async payload => api.delete('/banner', { params: payload })

export { list, createUpdate, deleteB }
